import './App.css';
import Canvas from './components/canvas/canvas';
// import Home from './components/home/home';

function App() {
  return (
    <div className="App w-full h-screen">
      {/* <Home /> */}
      <Canvas />
    </div>
  );
}

export default App;
